module.exports = __webpack_public_path__ + "img/ammerfeld_gemaelde.01d4cfe7.jpg";